module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image15.386a7a0f.webp";